import { RejectedUserRptConstants } from "../constants/RejectedUserRptConstants";

const initialState = {
  items: [],
  exportitems: [],
  loading: false,
  exporting: false,
  error: null,
};

export function RejectedUserRpt(state = initialState, action) {
  switch (action.type) {
    case RejectedUserRptConstants.LOADING_REQUEST:
      return {
        ...state,
        loading: action.isbool,
      };

    case RejectedUserRptConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RejectedUserRptConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.datas || [],
      };
    case RejectedUserRptConstants.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case RejectedUserRptConstants.GETALLEX_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RejectedUserRptConstants.GETALLEX_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.datas || [],
      };
    case RejectedUserRptConstants.GETALLEX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case RejectedUserRptConstants.GETEXPORTEX_REQUEST:
      return {
        ...state,
        exporting: true,
      };
    case RejectedUserRptConstants.GETEXPORTEX_SUCCESS:
      return {
        ...state,
        exporting: false,
        exportitems: action.datas || [],
      };
    case RejectedUserRptConstants.GETEXPORTEX_FAILURE:
      return {
        ...state,
        exporting: false,
        error: action.error,
      };

    case RejectedUserRptConstants.GETEXPORT_REQUEST:
      return {
        ...state,
        exporting: true,
      };
    case RejectedUserRptConstants.GETEXPORT_SUCCESS:
      return {
        ...state,
        exporting: false,
        exportitems: action.datas || [],
      };
    case RejectedUserRptConstants.GETEXPORT_FAILURE:
      return {
        ...state,
        exporting: false,
        error: action.error,
      };

    default:
      return state;
  }
}

